import {
  CANCELING_ORDER,
  CLEAR_ORDERS_DONE,
  GET_ORDERS_DONE,
  GETTING_ORDERS,
  SENDING_ORDER,
} from './constants';

export default {
  [CANCELING_ORDER](state, canceling) {
    state.cancelingOrder = canceling;
  },
  [CLEAR_ORDERS_DONE](state) {
    state.orders = [];
  },
  [GET_ORDERS_DONE](state, payload) {
    state.orders = payload;
  },
  [GETTING_ORDERS](state, getting) {
    state.gettingOrders = getting;
  },
  [SENDING_ORDER](state, sending) {
    state.sendingOrder = sending;
  },
};
